<template>
  <div class="layout">
    <div class="frist-div">
      <div class="layout-cardcount">
        <CardHeadCount :series="totalHeadCount" />
        <CardHeadManhour :series="totalHeadManhour" />
      </div>
      <CardAssetsGraph v-if="delay > 0" :label="label" :dataChart="dataChart" />
    </div>
    <div class="second-div">
      <CardSecond
        :listTag="listTag"
        :gateway1="gateway1"
        :gateway2="gateway2"
      ></CardSecond>
    </div>
    <div class="third-div">
      <WorkforceStatus :listTag="listTagMerge" />
    </div>
  </div>
</template>

<script>
import DonutChart from "@/components/ApexChart/DonutChart.vue";
import CardHeadCount from "./components/CardHeadCount.vue";
import CardHeadManhour from "./components/CardHeadManhour.vue";
import CardAssetsGraph from "./components/CardAssetsGraph.vue";
import WorkforceStatus from "./components/WorkforceStatus.vue";
import CardSecond from "./components/CardSecond.vue";

export default {
  components: {
    DonutChart,
    WorkforceStatus,
    CardHeadCount,
    CardHeadManhour,
    CardAssetsGraph,
    CardSecond,
  },
  data() {
    return {
      delay: 0,
      totalHeadCount: [4, 10],
      totalHeadManhour: [45, 100],
      mac: ["AC233FC064A9", "AC233FC064BF"],
      listTag: [],
      gateway1: [],
      gateway2: [],
      activeTag: [],
      listTagMerge: [],
      label: [],
      dataChart: [],
      manhouse: [],
      timeout: null,
    };
  },
  async mounted() {
    await this.getDataOne();
    await this.getData();
    setTimeout(() => {
      this.delay = 1;
    }, 100);
  },
  beforeDestroy() {
    clearTimeout(this.tinmeout);
  },
  methods: {
    async getDataOne() {
      try {
        let indoortag = await this.$API.get("indoortag");
        console.log("indoortag", indoortag.data);
        this.listTag = indoortag.data;
        console.log(this.totalHeadCount);
        let manhouse = await this.$API.get("indoortag/manhour");
        console.log("manhouse", manhouse.data);
        this.manhouse = manhouse;

        let label = [];
        let dataChart = [];
        for (let i = 0; i < manhouse.data.length; i++) {
          const el = manhouse.data[i];
          label.unshift(el.date);
          dataChart.unshift(el.count);
        }
        this.label = label;
        this.dataChart = dataChart;
        console.log(this.label, this.dataChart);
      } catch (error) {
        console.error(error);
      }
    },
    async getData() {
      try {
        let gateway1 = await this.$API.get("indoorgateway/" + this.mac[0]);
        console.log("gateway1", gateway1.data);
        let gateway2 = await this.$API.get("indoorgateway/" + this.mac[1]);
        console.log("gateway2", gateway2.data);
        // let indoortaglog = await this.$API.get("indoortaglog");
        // console.log("indoortaglog", indoortaglog.data);

        let arr_gateway1 = [];
        let arr_gateway2 = [];
        let listTagMerge = [];
        for (let i = 0; i < this.listTag.length; i++) {
          const el = this.listTag[i];
          let found1;
          if (gateway1.data[0]) {
            found1 = gateway1.data[0].tagfound.find(
              (element) => element.mac == el.mac
            );
            // console.log(found1);
            if (found1 != undefined) {
              // if (
              //   this.$moment(found1.timestamp).format("YYYY-MM-DD") ==
              //   this.$moment().format("YYYY-MM-DD")
              // ) {
              arr_gateway1.push(found1);
              // }
            }
          }
          let found2
          if (gateway2.data[0]) {
            found2 = gateway2.data[0].tagfound.find(
              (element) => element.mac == el.mac
            );
            console.log(found2);
            if (found2 != undefined) {
              console.log(this.$moment(found2.timestamp).format("YYYY-MM-DD"));
              // if (
              //   this.$moment(found2.timestamp).format("YYYY-MM-DD") ==
              //   this.$moment().format("YYYY-MM-DD")
              // ) {
              arr_gateway2.push(found2);
              // }
            }
          }
          let new_tag = { ...found1, ...found2, ...el };
          // console.log(new_tag);
          new_tag["last_location"] =
            found1 != undefined
              ? "Zone 1"
              : found2 != undefined
              ? "Zone 2"
              : "";

          new_tag["status"] =
            new_tag.lastdate.split(" ")[0] ==
            this.$moment().format("YYYY-MM-DD")
              ? "Present"
              : "Absent";
          // found1 != undefined
          //   ? "Present"
          //   : found2 != undefined
          //   ? "Present"
          //   : "Absent";
          let manhour = new_tag.lastdate == "Invalid date"
              ? 0
              : Number(this.$moment(new_tag.lastdate).diff(
                  this.$moment(new_tag.firstdate),
                  "minutes"
                ))

          new_tag["manhour"] = Math.floor(manhour/60)+'.'+(manhour%60);

          new_tag["distance"] =
            new_tag.rssi == undefined
              ? null
              : Math.pow(10, (-52 - new_tag.rssi) / (10 * 4)).toFixed(2);
          listTagMerge.push(new_tag);
        }
        console.log(listTagMerge);
        this.listTagMerge = listTagMerge;
        this.gateway1 = arr_gateway1;
        this.gateway2 = arr_gateway2;

        this.activeTag = arr_gateway1.concat(arr_gateway2);

        console.log(this.gateway1, this.gateway2);
        this.totalHeadCount = [
          this.manhouse.data[0].date == this.$moment().format("YYYY-MM-DD")
            ? this.manhouse.data[0].count
            : 0,
          this.listTag.length,
        ];
        this.totalHeadManhour = [
          this.manhouse.data[0].date == this.$moment().format("YYYY-MM-DD")
            ? this.manhouse.data[0].manhour
            : 0,
          this.listTag.length * 8,
        ];
        // get/indoortaglog
      } catch (error) {
        console.error(error);
      }

      this.timeout = setTimeout(async () => {
        await this.getData();
      }, 1000 * 10);
    },
  },
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex-direction: column;
  gap: 10px;
  // color: #b1fab8;
}

.frist-div {
  display: grid;
  grid: auto/30% auto;
  width: 100%;
  gap: 10px;
  .layout-cardcount {
    display: flex;
    gap: 10px;
    flex-direction: column;
  }
}
.second-div {
  // height: 260px;
}

@media only screen and (max-width: 508px) {
  .frist-div {
    display: grid;
    grid: auto auto/ auto;
    width: 100%;
    gap: 10px;
  }
}
</style>